import React, { ReactElement } from 'react';
import { useRecoilValue } from 'recoil';
import { ICustomer, ICustomerDocument } from '../../lib/types';
import {
   customerDocumentFilterAtom,
   customerDocumentFiltersSelector,
   filteredCustomerDocumentsSelector,
   filteredCustomerDocumentViolationSelector,
} from '../../recoil/customer-document-filter';
import Calendar from '../calendar/calendar';
import DocumentCard from '../document-card/document-card';
import FilterDropdown, {
   IFilterDropdownProps,
} from '../filter-dropdown/filter-dropdown';
import HelpModal from '../help-modal/help-modal';
import SecondaryButton from '../secondary-button/secondary-button';
import './customer-documents.scss';

export interface ICustomerDocumentProps {
   customer: ICustomer;
   onLoaded?: () => void;
}

export function CustomerDocuments(props: ICustomerDocumentProps): ReactElement {
   const [isLoading, setIsLoading] = React.useState(true);

   const customerDocumentsFiltered: ICustomerDocument[] = useRecoilValue(
      filteredCustomerDocumentsSelector(props.customer.id)
   );

   const customerDocumentViolationFiltered: ICustomerDocument[] = useRecoilValue(
      filteredCustomerDocumentViolationSelector(props.customer.id)
   );
   const customerDocumentFilters: string[] = useRecoilValue(
      customerDocumentFiltersSelector(props.customer.id)
   );

   const dropdownFilterProps: IFilterDropdownProps = {
      filters: customerDocumentFilters,
      filterAtom: customerDocumentFilterAtom,
      clearHeader: false,
      defaultFilter: 'All documents',
      uniqueName: 'documents',
   };

   const [modalClass, setModalClass] = React.useState('modal-hidden');
   const showModal = (): void => {
      setModalClass('');
   };

   // Simulate API/Data loading
   React.useEffect(() => {
      setTimeout(() => {
         setIsLoading(false);
         props.onLoaded?.(); // Notify parent that loading is complete
      }, 500); // Simulate loading time
   }, [customerDocumentViolationFiltered]);

   return (
      <div className="customer-documents">
         <div className="customer-documents-header">
            {/* <FilterDropdown
               filters={dropdownFilterProps.filters}
               filterAtom={dropdownFilterProps.filterAtom}
               clearHeader={dropdownFilterProps.clearHeader}
               defaultFilter={dropdownFilterProps.defaultFilter}
               uniqueName={dropdownFilterProps.uniqueName}
            /> */}
            <Calendar />
         </div>
         
         {isLoading ? (
            <div className="loader body-large-regular">Loading documents...</div>
         ) : customerDocumentViolationFiltered.length > 0 ? (
            <div className="customer-documents-list">
               {customerDocumentViolationFiltered.map((customerDocument) => (
                  <DocumentCard
                     key={customerDocument.id}
                     customerDocument={customerDocument}
                     showBadge={true}
                  />
               ))}
            </div>
         ) : (
            <div className="no-documents body-large-regular">No documents available</div>
         )}

         {/* <div className="customer-documents-help-text body-small-regular">
            No other documents within the selected date range.
         </div> */}
         <SecondaryButton
            text="Not seeing what you’re looking for?"
            action={showModal}
         />
         <HelpModal modalClass={modalClass} setModalClass={setModalClass} />
      </div>
   );
}
